"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLanguageLink = void 0;
/** Replace the `linkUrl` of the provided link with `"/[languageCode]/[rest-of-window.location]"`.
 * @example
 * createLanguageLink({ linkText: 'English', linkUrl: '/en', linkTarget: '_blank', linkData: { languageCode: 'en' }})
 * // => { linkText: 'English', linkUrl: '/en/path/to/current/page?q=test#anchor', linkTarget: '_blank', linkData: { languageCode: 'en' }} */
// eslint-disable-next-line import/prefer-default-export
var createLanguageLink = function (link) {
  var _a, _b, _c;
  if (typeof window === 'undefined') return link;
  if (((_a = link === null || link === void 0 ? void 0 : link.linkData) === null || _a === void 0 ? void 0 : _a.languageCode) === undefined) return link;
  var paths = window.location.pathname.split('/');
  if (paths.length < 2) return link;
  paths[1] = (_c = (_b = link.linkData) === null || _b === void 0 ? void 0 : _b.languageCode) !== null && _c !== void 0 ? _c : paths[1];
  return __assign(__assign({}, link), {
    linkUrl: paths.join('/') + window.location.search + window.location.hash
  });
};
exports.createLanguageLink = createLanguageLink;